import React from 'react';
import { FormControl, FormHelperText, FormLabel } from './base/FormControl/FormControl';
import Select from './base/Select/Select';
import '../styles.css'; // Import styles for the component
export default function Dropdown(_a) {
    var name = _a.name, origin = _a.origin, value = _a.value, label = _a.label, options = _a.options, onChange = _a.onChange, error = _a.error, helperText = _a.helperText, disabled = _a.disabled, dataTestId = _a["data-testid"];
    return (React.createElement(FormControl, { error: error, "data-testid": dataTestId },
        React.createElement(FormLabel, { htmlFor: name }, label),
        React.createElement(Select, { name: name, value: value, options: options, onChange: onChange, origin: origin, disabled: disabled, "data-testid": dataTestId ? "".concat(dataTestId, "-select") : undefined }),
        helperText && (React.createElement(FormHelperText, null,
            helperText,
            "\u00A0"))));
}
//# sourceMappingURL=Dropdown.js.map